var _g, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThreetonpickup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "1,8.1 15.2,8.1 15.2,6.5 16,6.5 16,13.3 1,13.3  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000"
    },
    d: "M17.9,8.2c0,0.8,0,1.7,0,2.6c0.8,0,1.6,0,2.5,0c-0.2-0.8-0.5-1.7-0.7-2.6C19,8.2,18.5,8.2,17.9,8.2z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6,15c-0.3,0-0.5,0.2-0.6,0.5c0,0,0,0.1,0,0.1c0,0.2,0.1,0.3,0.2,0.4c0.1,0.1,0.2,0.1,0.4,0.1 c0.1,0,0.3,0,0.4-0.1c0.1-0.1,0.2-0.3,0.2-0.4c0,0,0-0.1,0-0.1C19.1,15.2,18.9,15,18.6,15z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.8,15.2c-0.1-0.1-0.3-0.3-0.5-0.3c-0.2,0-0.4,0.1-0.5,0.3c0,0-0.1,0.1-0.1,0.2c0,0,0,0.1,0,0.1 c0,0.2,0.1,0.3,0.2,0.4C3,16,3.2,16.1,3.3,16.1c0.1,0,0.3,0,0.4-0.1c0.1-0.1,0.2-0.3,0.2-0.4c0,0,0-0.1,0-0.1 C3.9,15.3,3.9,15.3,3.8,15.2z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000"
    },
    d: "M21,13.4c0,0.3,0,0.6,0,0.9c0.5,0,1,0,1.5,0c0-0.3,0-0.6,0-0.9C22,13.4,21.5,13.4,21,13.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M18.6,13.6c-1.1,0-1.9,0.9-1.9,1.9s0.9,1.9,1.9,1.9c1.1,0,1.9-0.9,1.9-1.9S19.7,13.6,18.6,13.6z M19,16 c-0.1,0.1-0.2,0.1-0.4,0.1c-0.1,0-0.3,0-0.4-0.1c-0.1-0.1-0.2-0.3-0.2-0.4c0,0,0-0.1,0-0.1c0-0.3,0.3-0.5,0.6-0.5 s0.5,0.2,0.6,0.5c0,0,0,0.1,0,0.1C19.2,15.7,19.1,15.9,19,16z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M3.4,13.6L3.4,13.6c-1,0-1.8,0.7-1.9,1.6c0,0.1,0,0.2,0,0.4c0,1.1,0.9,1.9,1.9,1.9s1.9-0.9,1.9-1.9 c0-0.1,0-0.2,0-0.3C5.1,14.3,4.3,13.6,3.4,13.6z M3.7,16c-0.1,0.1-0.2,0.1-0.4,0.1c-0.1,0-0.3,0-0.4-0.1 c-0.1-0.1-0.2-0.3-0.2-0.4c0,0,0-0.1,0-0.1c0-0.1,0-0.2,0.1-0.2c0.1-0.1,0.3-0.3,0.5-0.3c0.2,0,0.4,0.1,0.5,0.3 c0,0,0.1,0.1,0.1,0.2c0,0,0,0.1,0,0.1C3.9,15.7,3.9,15.9,3.7,16z"
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.7,13.6H1v1.6h0.3l0,0C1.5,14.5,2,13.8,2.7,13.6z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6,14.2c0-0.9,0-1.8,0-2.6c-0.3-0.1-0.6-0.3-0.8-0.4c-0.2-0.1-0.4-0.2-0.6-0.3c0,0,0,0-0.1,0 c-0.4-0.2-0.4-0.7-0.5-1.1c-0.2-0.7-0.4-1.3-0.6-1.9c-0.1-0.4-0.2-0.8-0.1-1.3c-1.1,0-2.3,0-3.4,0l0,0l0,0l0,0v1.4l0,0 c0,1.9,0,3.8,0,5.6H4.1c0.7,0.3,1.2,0.8,1.3,1.6l0,0h11c0.3-0.9,1-1.8,2-1.8c1.1-0.2,2.2,0.7,2.4,1.8c0.7,0,1.5,0,2.2,0 c0-0.3,0-0.6,0-0.9C22.9,14.2,22.7,14.2,22.6,14.2z M17.9,10.8c0-0.8,0-1.7,0-2.6c0.6,0,1.1,0,1.7,0c0.2,0.8,0.5,1.7,0.7,2.6 C19.5,10.8,18.7,10.8,17.9,10.8z M22.5,14.3c-0.5,0-1,0-1.5,0c0-0.3,0-0.6,0-0.9c0.5,0,1,0,1.5,0C22.5,13.7,22.5,14,22.5,14.3z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreetonpickup);
export default __webpack_public_path__ + "static/media/threetonpickup.29828a6325f016107f39e5462349cc61.svg";
export { ForwardRef as ReactComponent };